/** 필터 필드 id — 그대로 폼 값 키가 된다. */
export const FIELD_NAMES = {
  shipperCode: 'shipperCode',
  brandName: 'brandName',
  goodsCode: 'goodsCode',
  barcodes: 'barcodes',
} as const

/** 브랜드명 '전체' 옵션 값 — pbo-core 공통 멀티셀렉트와 같게 빈 문자열이다(선택 시 브랜드 필터를 안 싣는다). */
export const ALL_BRANDS = ''

/**
 * 엑셀 다운로드 행수 상한 — BE `MAX_EXCEL_ROW_SIZE` 와 동일(LOGISPRD-9597).
 * 핸드오프의 1.0 라인(50,000행 알럿)은 폐기 — ST02(9593)/ST03(9595)/ST07(9597) 이 100,000행으로 통일했다.
 * 서버도 count 선검사로 400 을 주므로 여기 선차단은 왕복 절약용이다.
 */
export const EXCEL_ROW_LIMIT = 100_000

/** 그리드 기본 페이지 크기. */
export const DEFAULT_PAGE_SIZE = 50

/** 엑셀 사유 모달의 상세사유 최소 길이 — 1.0 RemarkPop 검증과 동일(옛 ExcelDownloadReasonModal 에서 이관). */
export const REASON_DETAIL_MIN_LENGTH = 5

export const MESSAGES = {
  searchFailed: '조회 중 오류가 발생했습니다.',
  excelReasonRequired: '사유코드를 선택해 주세요.',
  excelReasonDetailTooShort: `상세사유를 ${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해 주세요.`,
  excelNoRows: '다운로드할 데이터가 없습니다.',
  excelRowLimitExceeded: `엑셀 다운로드 최대 행수(${EXCEL_ROW_LIMIT.toLocaleString()}행)를 초과했습니다. 조회 조건을 추가해 주세요.`,
  /** 상품코드 서치헬퍼 — goods-codes 는 무페이징 distinct 라 조건 없이 받지 않는다(index.tsx enabled). */
  goodsHelperConditionRequired: '브랜드명 또는 상품명을 입력한 뒤 조회해 주세요.',
} as const
